import * as moment from "moment-recent";
import { IContractViewModel } from "@/Scripts/inpulse/I4UViewModels";
import { CustomerTypeEnum, ContractReasonEnum } from "@/Scripts/inpulse/CommonEnums";
import { IContractSettings } from "./new-contract-vuex-store";

// moving some methods from (te) vue components here, instead of duplicating in several components...

class NewContractVueHelper {

    startDateMin(contract: IContractViewModel, contractSettings: IContractSettings): string {
        // This logic is copied from old newcontract script (newContract-common.js), added with some logic that handles weirdnes of Uiv's date picker limit.
        let min = moment();

        let movingMinDates = contractSettings.MovingMinDates;
        if (contract.CustomerType == CustomerTypeEnum.COMPANY && contractSettings.MovingMinDatesCompany != null)
            movingMinDates = contractSettings.MovingMinDatesCompany;

        let supplierChangeMinDates = contractSettings.SupplierChangeMinDates;
        if (contract.CustomerType == CustomerTypeEnum.COMPANY && contractSettings.SupplierChangeMinDatesCompany != null)
            supplierChangeMinDates = contractSettings.SupplierChangeMinDatesCompany;

        let days = movingMinDates;

        // If supplier change or product change, then SupplierChangeMinDates is used.
        let contractReason = contract.ContractReason;
        if (contractReason == ContractReasonEnum.SUPPLIERCHANGE || contractReason == ContractReasonEnum.PRODUCTCHANGE || contractReason == ContractReasonEnum.NOTKNOWN
            || contractReason == ContractReasonEnum.SUPPLIERCHANGE_DH) {
            days = supplierChangeMinDates;
        }

        // Add days to current date.
        min.add(days, "d");

        // This crap is for UIV's date picker limit handling.
        let minStr = min.format("DD.MM.YYYY") + " 00:00:00 GMT";
        return minStr;
    }

    startDateMin_DH(contract: IContractViewModel, contractSettings: IContractSettings): string {
        let days: number = 0;
        let min = moment();
        if (contract.ContractReason == ContractReasonEnum.PRODUCTCHANGE_DH) {
            days = contractSettings.ProductChangeMinDates;
            if (contract.CustomerType == CustomerTypeEnum.COMPANY) {
                days = contractSettings.ProductChangeMinDatesCompany;
            }
        }
        else if (contract.ContractReason == ContractReasonEnum.MOVEIN_DH) {
            days = contractSettings.MovingMinDates;
            if (contract.CustomerType == CustomerTypeEnum.COMPANY) {
                days = contractSettings.MovingMinDatesCompany;
            }
        }
        else if (contract.ContractReason == ContractReasonEnum.SUPPLIERCHANGE_DH) {
            days = contractSettings.SupplierChangeMinDates;            
            if (contract.CustomerType == CustomerTypeEnum.COMPANY) {
                days = contractSettings.SupplierChangeMinDatesCompany;
            }
        }

        // Add days to current date.
        min.add(days, "d");

        // This crap is for UIV's date picker limit handling.
        let minStr = min.format("DD.MM.YYYY") + " 00:00:00 GMT";
        return minStr;
    }

    getYear(date: Date): number {
        let m = moment(date, "DD.MM.YYYY");
        let year = m.format('YYYY');
        let yy = parseInt(year);
        return yy
    }

    getMonth(date: Date): number {
        let m = moment(date, "DD.MM.YYYY");
        let month = m.format('M');
        let mm = parseInt(month) - 1;
        return mm
    }

    getDay(date: Date): number {
        let m = moment(date, "DD.MM.YYYY");
        let day = m.format('DD');
        let dd = parseInt(day);
        return dd
    }

    getDate(date: Date): Date {
        return new Date(this.getYear(date), this.getMonth(date), this.getDay(date));
    }

    // returns true for dates to disable
    // date: The date as a Date object
    // weekDaysToDisable ex. [0,6], to disable weekends
    // datesToDisable - list of dates in D.M.YYYY format
    disableDates(date: Date, weekDaysToDisable: number[], datesToDisable: string[]): boolean { 
        let momentDate = moment(date, "DD.MM.YYYY").format("D.M.YYYY");
        if (weekDaysToDisable.indexOf(date.getDay()) !== -1)
            return true;
        if (datesToDisable !== null)
            return datesToDisable.indexOf(momentDate) !== -1;
    }
}

export {
    NewContractVueHelper
};